import type { ScrollToOptions } from '@tanstack/react-virtual';

export const SCROLL_OPTIONS_START: ScrollToOptions = { align: 'start' };
export const SCROLL_OPTIONS_END: ScrollToOptions = { align: 'end' };

export const OBSERVE_ROOT_MARGIN = '100px';
